import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { tableMemory } from "../../../Objects/Memory/Memory"
import { TablesPupop } from "./TablesPupop"
import { Tables } from "../../../Objects/Table/Tables"
import { useGetTables } from "../../../hooks/Tables/useGetTables"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"

export const TablesPage: React.FC = () => {
  const { t } = useTranslation("tables")

  const [enableMeals, setEnableMeals] = useState(false)

  const { handleGetTable } = useGetTables()

  const [tablesData, setTablesData] = useState<Tables | undefined>(undefined)

  useEffect(() => {
    handleGetTable(() => {})
  }, [])

  const handleOpenEditePromotion = (id: number) => {
    const promotion = tableMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setTablesData(promotion)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setTablesData(undefined)

    setEnableMeals(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          data={tableMemory.getListCards(true)}
          messageCount={t("list:label_table_page_message_count")}
          messageEmpty={t("list:label_table_page_message_empty")}
          nameFindSearch={t("list:label_table_page_place_holder")}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleRefreshButton={() => handleGetTable(() => {})}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
        />
      </div>

      {enableMeals && (
        <TablesPupop
          tableData={tablesData}
          title={tablesData ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
        />
      )}
    </>
  )
}
